import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseScheduledItemDetailComponent } from '@leads/client-facing/classes/base-scheduled-item-detail.component';
import { ScheduledItemTitleComponent } from '@leads/client-facing/components/scheduled-item-title/scheduled-item-title.component';
import { AssessmentStatusDropdownComponent } from '@leads/shared/components/assessment-status-dropdown/assessment-status-dropdown.component';
import { DropdownControlComponent } from '@shared/components/forms/dropdown-control/dropdown-control.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { HeaderPopoverComponent } from '@shared/components/sections/header-popover/header-popover.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';

@Component({
	selector: 'app-mobile-scheduled-item-detail-offcanvas',
	imports: [
		CommonModule,
		StepNavigatorComponent,
		LoadingStateComponent,
		TextareaControlComponent,
		FormsModule,
		AssessmentStatusDropdownComponent,
		ScheduledItemTitleComponent,
		DropdownControlComponent,
		TextareaControlComponent,
		HeaderPopoverComponent,
	],
	templateUrl: './mobile-scheduled-item-detail-offcanvas.component.html',
	styleUrl: './mobile-scheduled-item-detail-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class MobileScheduledItemDetailOffcanvasComponent extends BaseScheduledItemDetailComponent {
	@Input() index: number;

	close(): void {
		this.offcanvasService.dismissLast();
	}
}
